import React from 'react';
import { useFormContext, useWatch, useFieldArray, Controller } from 'react-hook-form';
import { ErrorMessage } from '@hookform/error-message';
import Checkbox from '@/Shared/Form/Checkbox';
import Input from '@/Shared/Form/Input';
import FormSelect from '@/Shared/Form/Select';
import { legalBasisOptions } from '@/lib/settings';

const CategoryChecbox = ({ index, field, onRemoveCustom = () => { } }) => {
  const { control, formState: { errors } } = useFormContext();

  const category = field;
  const isChecked = category.isCustom ? true : !!useWatch({ name: `collectInfo[${index}].value`, control });
  const inputEl = React.useRef(null);


  const { fields: customSubcategoryFields, append: appendCustomSubcategory, remove: removeCustomSubcategory } = useFieldArray({
    control,
    name: `collectInfo[${index}].customSubcategories`,
  });

  const addCustomSubcategory = () => {
    const value = inputEl.current.value;
    if (value.trim().length === 0) {
      return;
    }
    appendCustomSubcategory({
      label: value,
      value: true,
      isCustom: true,
    });
    inputEl.current.value = '';
  };

  return (
    <div className="mb-5">
      <div className="d-flex align-items-center">
        <Controller
          name={`collectInfo[${index}].value`}
          control={control}
          defaultValue={category.value}
          render={({ field: { onChange, value, ref } }) => (
            <Checkbox
              label={category.label}
              checked={value}
              readOnly={category.isCustom}
              onChange={category.isCustom ? undefined : onChange}
              ref={ref}
            />
          )}
        />
        {category.isCustom && onRemoveCustom && (
          <span className='ms-2 cursor-pointer' onClick={onRemoveCustom}>
            <i className='fas fa-minus-square text-danger fs-2' />
          </span>
        )}
      </div>

      {category.isCustom && (
        <div className="ms-5 ps-5">
          <div className="mb-3">
            <Input
              name={`collectInfo[${index}].whatWeCollect`}
              labelText="What we collect"
              isRequired
            />
          </div>
          <div className="mb-3">
            <Input
              name={`collectInfo[${index}].purpose`}
              labelText="Purpose"
              isRequired
            />
          </div>
        </div>
      )}

      {isChecked && (
        <div className="ms-5 ps-5">
          <div className="row mb-3">
            <div className="col-md-6">
              <Input
                name={`collectInfo[${index}].retentionPeriod`}
                labelText="Retention Period (in days)"
                type="number"
                placeholder="e.g. 30"
                isRequired
              />
            </div>
            <div className="col-md-6">
              <label className='form-label required'>Legal Basis</label>
              <Controller
                name={`collectInfo[${index}].legalBasis`}
                control={control}
                render={({ field }) => (
                  <FormSelect
                    {...field}
                    options={legalBasisOptions}
                    getOptionLabel={(option) => option.label}
                    getOptionValue={(option) => option.value}
                    getOptionEqual={(option) => option.value}
                  />
                )}
              />
              <ErrorMessage
                errors={errors}
                name={`collectInfo[${index}].legalBasis`}
                render={({ message }) => (
                  <small className="text-danger">
                    {message}
                  </small>
                )}
              />
            </div>
          </div>

          {category.subcategories && category.subcategories.length > 0 && category.subcategories.map((sub, subIndex) => (
            <Controller
              key={sub.id}
              name={`collectInfo[${index}].subcategories[${subIndex}].value`}
              control={control}
              render={({ field: { onChange, value, ref } }) => (
                <Checkbox
                  label={sub.label}
                  checked={value}
                  onChange={onChange}
                  ref={ref}
                />
              )}
            />
          ))}
          {category.subcategories && category.subcategories.length > 0 &&
            <ErrorMessage
              errors={errors}
              name={`collectInfo[${index}].subcategories`}
              render={({ message }) => (
                <small className="text-danger">
                  {message}
                </small>
              )}
            />
          }

          {customSubcategoryFields.map((sub, subIndex) => (
            <div key={sub.id} className='d-flex align-items-center'>
              <Controller
                name={`collectInfo[${index}].customSubcategories[${subIndex}].value`}
                control={control}
                defaultValue={sub.value}
                render={({ field: { onChange, value, ref } }) => (
                  <Checkbox
                    label={sub.label}
                    checked={value}
                    readOnly={true}
                    onChange={undefined}
                    ref={ref}
                  />
                )}
              />
              <span className='ms-2 cursor-pointer' onClick={() => removeCustomSubcategory(subIndex)}>
                <i className='fas fa-minus-square text-danger fs-2' />
              </span>
            </div>
          ))}

          {category.isCustomSubcategories && (
            <div className='input-group w-50 mt-2 mb-2'>
              <input ref={inputEl} type='text' className='form-control' placeholder='Add more...' />
              <button className='btn btn-success' type='button' onClick={addCustomSubcategory}>
                <i className='fas fa-plus' />
              </button>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default CategoryChecbox; 